module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/isNaN.js
// module id = 13
// module chunks = 0